import { sendMail } from '@/api/mail/index';
import gestionErreur from '@/services/general/gestionErreur';

export default async function envoiMail(loadingComponent, payload) {
  if (payload.dropFiles) {
    payload.mail.piecesJointes = payload.dropFiles;
  }
  const data = new FormData();
  data.append('mailRequest', JSON.stringify(payload.mail));
  if (payload.dropFiles) {
    payload.dropFiles.forEach((file) => {
      data.append(file.name, file, file.name);
    });
  }
  let valid = true;
  if (payload.mail.To.length === 0) {
    gestionErreur('Destinataire obligatoire');
    valid = false;
  } else if (payload.mail.Cci.length === 0) {
    gestionErreur('Cci obligatoire');
    valid = false;
  } else if (!payload.mail.Objet) {
    gestionErreur('L\'objet du mail est obligatoire');
    valid = false;
  } else if (!payload.mail.replyTo) {
    gestionErreur('Le `De` du mail est obligatoire');
    valid = false;
  } else if (!payload.mail.Corps) {
    gestionErreur('Le corps du mail est obligatoire');
    valid = false;
  }
  if (payload.mail.To.length > 0 && payload.mail.Cci.length > 0) {
    const isCciSameToTo = payload.mail.To.filter((item) => {
      return payload.mail.Cci.filter(c => {
        return c === item;
      }).length > 0;
    }).length > 0;
    if (isCciSameToTo) {
      gestionErreur('impossible d\'envoyer le mail les adresses email "Cci" et "A" doivent être différentes');
      valid = false;
    }
  }
  if (valid) {
    await sendMail(data, payload.url);
    return true;
  }
  return false;
}



// WEBPACK FOOTER //
// ./src/services/general/envoiMail.js